import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=9a116ff6&scoped=true"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"
import style0 from "./channel.vue?vue&type=style&index=0&id=9a116ff6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a116ff6",
  null
  
)

export default component.exports